import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-page-retrieval-error',
    templateUrl: './page-retrieval-error.component.html',
    styleUrls: ['./page-retrieval-error.component.scss'],
    imports: [RouterLink],
})
export class PageRetrievalErrorComponent {}
